export default __webpack_public_path__ + "static/media/left.c289fe8b.svg";